const currentTheme = localStorage.getItem('theme')
const theme = {
  defaultTheme: { primaryText: '#1b4b63', secondaryText: '#BECBD2', primaryButton: '#45C1B8', secondaryButton: '#BBBBBB', activeMenu: '#143E52', danger: '#ff2626', sideBarTrigger: '#002140', topHeaderBar: '#1B4B63' },
  onSiteBloodDonationTheme: { primaryText: '#27A06D', secondaryText: '#1D7852 ', primaryButton: '#27A06D', secondaryButton: '#1D7852 ', activeMenu: '#1D7852 ', danger: '#ff0000', sideBarTrigger: '#1D7852 ', topHeaderBar: '#27A06D' },
}

export default currentTheme ? theme[currentTheme] : theme['defaultTheme']
